// extracted by mini-css-extract-plugin
module.exports = {"container":"LocationSeoLinks_container__FN2uI","tags":"LocationSeoLinks_tags__j34dN"};